<mat-form-field subscriptSizing="dynamic">
  <mat-label [translate]="translationKey"></mat-label>
  <input
    matInput
    [ngxMatDatetimePicker]="picker"
    (focus)="picker.open()"
    [required]="required"
    [ngModel]="value"
    (ngModelChange)="onValueChange($event)"
    [errorStateMatcher]="errorStateMatcher"
    [disabled]="disabled"
    autocomplete="off"
  />
  <app-mat-datepicker-toggle matSuffix [for]="picker"></app-mat-datepicker-toggle>
  <ngx-mat-datetime-picker #picker color="primary" [showSpinners]="true" [showSeconds]="false">
    <ngx-mat-datepicker-actions>
      <button mat-button ngxMatDatepickerCancel translate="COMMON.CANCEL"></button>
      <button mat-raised-button color="primary" ngxMatDatepickerApply translate="COMMON.APPLY"></button>
    </ngx-mat-datepicker-actions>
  </ngx-mat-datetime-picker>
  @if (isDateInvalid && errorMessageKey) {
    <mat-error [translate]="errorMessageKey"></mat-error>
  }
</mat-form-field>
